import { render } from "./DepartamentosPaquete.vue?vue&type=template&id=8c017984"
import script from "./DepartamentosPaquete.vue?vue&type=script&lang=js"
export * from "./DepartamentosPaquete.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__